<script setup lang="ts">
import { TagIcon } from 'lucide-vue-next'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import TagBox from '@/components/TagMenu/TagBox.vue'
import { useTagBox } from '@/composables/tags/useTagBox'
import type { Elemental } from '~~/src/types/elemental'
const props = defineProps<{
  elemental: Elemental
}>()

defineOptions({
  name: 'OpenTagBox',
})

const { open, toggleOpen, isLoading } = useTagBox(props.elemental)
</script>

<template>
  <DropdownMenu :open="open" @update:open="toggleOpen">
    <DropdownMenuTrigger :disabled="isLoading" class="w-full">
      <DropdownMenuItem>
        <TagIcon />
        Add Tag
      </DropdownMenuItem>
    </DropdownMenuTrigger>
    <DropdownMenuContent>
      <TagBox :open="open" :elemental="elemental" />
    </DropdownMenuContent>
  </DropdownMenu>
</template>
